<!-- src/app/views/pericia/listado-pericia/listado-pericia.component.html -->
<mat-card appearance="outlined" *appRoles="['Pericias.Listar']">
  <mat-card-header [hidden]="!showHeader">
    <div class="header-nombre-nuevo">
      <h2>Pericias</h2>
      <app-button-new (click)="openDialog({ accion: accionesDialog.Agregar})"></app-button-new>
    </div>
  </mat-card-header>

  <!-- Contenido de filtros -->
  <mat-card-content>
    <form [formGroup]="formFilter">
      <!-- Filtros básicos - siempre visibles -->
      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Descripción</mat-label>
            <input matInput type="text" formControlName="Descripcion" />
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Lugar</mat-label>
            <input matInput type="text" formControlName="Lugar" />
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Tipos de Pericia</mat-label>
            <mat-select multiple formControlName="IdsTipoPericia">
              <mat-option [value]="tipo.id" *ngFor="let tipo of tiposPericia; trackBy: trackByItems">
                {{ tipo.descripcion }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Estados de Pericia</mat-label>
            <mat-select multiple formControlName="IdsEstadoPericia">
              <mat-option [value]="estado.id" *ngFor="let estado of estadosPericia; trackBy: trackByItems">
                {{ estado.descripcion }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <!-- Filtros de fechas principales -->
      <div class="row">
        <div class="col-sm-12 col-md-6 col-lg-4"  *ngIf="checkedFiltroAvanzado">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Rango Fecha Propuesta</mat-label>
            <mat-date-range-input [rangePicker]="pickerPropuesta">
              <input matStartDate placeholder="Desde" formControlName="FechaPropuestaDesde">
              <input matEndDate placeholder="Hasta" formControlName="FechaPropuestaHasta">
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="pickerPropuesta"></mat-datepicker-toggle>
            <mat-date-range-picker #pickerPropuesta></mat-date-range-picker>
          </mat-form-field>
        </div>
        <div class="col-sm-12 col-md-6 col-lg-4"  *ngIf="checkedFiltroAvanzado">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Rango Fecha Realizada</mat-label>
            <mat-date-range-input [rangePicker]="pickerRealizada">
              <input matStartDate placeholder="Desde" formControlName="FechaRealizadaDesde">
              <input matEndDate placeholder="Hasta" formControlName="FechaRealizadaHasta">
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="pickerRealizada"></mat-datepicker-toggle>
            <mat-date-range-picker #pickerRealizada></mat-date-range-picker>
          </mat-form-field>
        </div>
      </div>

      <!-- Filtros avanzados -->
      <div class="row">
        <!-- Fechas de auditoría -->
        <div class="col-sm-12 col-md-6 col-lg-4"  *ngIf="checkedFiltroAvanzado">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Rango Fecha Alta</mat-label>
            <mat-date-range-input [rangePicker]="pickerAlta">
              <input matStartDate placeholder="Desde" formControlName="FechaAltaDesde">
              <input matEndDate placeholder="Hasta" formControlName="FechaAltaHasta">
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="pickerAlta"></mat-datepicker-toggle>
            <mat-date-range-picker #pickerAlta></mat-date-range-picker>
          </mat-form-field>
        </div>
        <div class="col-sm-12 col-md-6 col-lg-4"  *ngIf="checkedFiltroAvanzado">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Rango Fecha Modificación</mat-label>
            <mat-date-range-input [rangePicker]="pickerModificacion">
              <input matStartDate placeholder="Desde" formControlName="FechaModificacionDesde">
              <input matEndDate placeholder="Hasta" formControlName="FechaModificacionHasta">
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="pickerModificacion"></mat-datepicker-toggle>
            <mat-date-range-picker #pickerModificacion></mat-date-range-picker>
          </mat-form-field>
        </div>

        <!-- Fechas de cédulas -->
        <div class="col-sm-12 col-md-6 col-lg-4"  *ngIf="checkedFiltroAvanzado">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Rango Cédula Presentación</mat-label>
            <mat-date-range-input [rangePicker]="pickerCedulaPresentacion">
              <input matStartDate placeholder="Desde" formControlName="FechaCedulaPresentacionDesde">
              <input matEndDate placeholder="Hasta" formControlName="FechaCedulaPresentacionHasta">
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="pickerCedulaPresentacion"></mat-datepicker-toggle>
            <mat-date-range-picker #pickerCedulaPresentacion></mat-date-range-picker>
          </mat-form-field>
        </div>
        <div class="col-sm-12 col-md-6 col-lg-4"  *ngIf="checkedFiltroAvanzado">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Rango Vence Presentación</mat-label>
            <mat-date-range-input [rangePicker]="pickerVencePresentacion">
              <input matStartDate placeholder="Desde" formControlName="FechaVencePresentacionDesde">
              <input matEndDate placeholder="Hasta" formControlName="FechaVencePresentacionHasta">
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="pickerVencePresentacion"></mat-datepicker-toggle>
            <mat-date-range-picker #pickerVencePresentacion></mat-date-range-picker>
          </mat-form-field>
        </div>
        <div class="col-sm-12 col-md-6 col-lg-4"  *ngIf="checkedFiltroAvanzado">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Rango Acepta Cargo</mat-label>
            <mat-date-range-input [rangePicker]="pickerAceptaCargo">
              <input matStartDate placeholder="Desde" formControlName="FechaAceptaCargoDesde">
              <input matEndDate placeholder="Hasta" formControlName="FechaAceptaCargoHasta">
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="pickerAceptaCargo"></mat-datepicker-toggle>
            <mat-date-range-picker #pickerAceptaCargo></mat-date-range-picker>
          </mat-form-field>
        </div>

        <!-- Fechas de proceso -->
        <div class="col-sm-12 col-md-6 col-lg-4"  *ngIf="checkedFiltroAvanzado">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Rango Propone Pericia</mat-label>
            <mat-date-range-input [rangePicker]="pickerPropone">
              <input matStartDate placeholder="Desde" formControlName="FechaProponeDesde">
              <input matEndDate placeholder="Hasta" formControlName="FechaProponeHasta">
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="pickerPropone"></mat-datepicker-toggle>
            <mat-date-range-picker #pickerPropone></mat-date-range-picker>
          </mat-form-field>
        </div>
        <div class="col-sm-12 col-md-6 col-lg-4"  *ngIf="checkedFiltroAvanzado">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Rango Realiza Pericia</mat-label>
            <mat-date-range-input [rangePicker]="pickerRealiza">
              <input matStartDate placeholder="Desde" formControlName="FechaRealizaDesde">
              <input matEndDate placeholder="Hasta" formControlName="FechaRealizaHasta">
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="pickerRealiza"></mat-datepicker-toggle>
            <mat-date-range-picker #pickerRealiza></mat-date-range-picker>
          </mat-form-field>
        </div>
      </div>

      <div class="row align-items-center">
        <div class="col-auto">
          <div style="display: flex; align-items: center; gap: 8px;">
            <app-button-filter-table (click)="aplicarFiltro()"></app-button-filter-table>
            <app-button-filter-table-clear (click)="limpiarFiltro()"></app-button-filter-table-clear>
          </div>
        </div>
        <div class="col-auto">
          <mat-slide-toggle [checked]="checkedFiltroAvanzado" (change)="filtrosAvanzados($event)" color="primary">
            Filtros Avanzados
          </mat-slide-toggle>
        </div>
      </div>

       <app-action-buttons-filter [checkedFiltroAvanzado]="checkedFiltroAvanzado"
          [menuFiltroAvanzado]="menuFiltroAvanzado" (aplicarFiltro)="aplicarFiltro()" (limpiarFiltro)="limpiarFiltro()"
          (menuOpened)="onMenuOpened()" (menuClosed)="onMenuClosed()">
        </app-action-buttons-filter>
    </form>
  </mat-card-content>

  <mat-card-content>
    <mat-divider></mat-divider>
    <ngx-spinner [zIndex]="100" name="spPericias" bdColor="rgba(255,255,255,0.8)" size="default"
      color=" var(--primary-color)" type="ball-atom" [fullScreen]="false">
    </ngx-spinner>

    <ngx-spinner [zIndex]="100" name="spNotificacion" bdColor="rgba(255,255,255,0.8)" size="default"
      color=" var(--primary-color)" type="ball-atom" [fullScreen]="false">
    </ngx-spinner>

    <!-- Inicio Contenedor acciones tabla -->
    <div class="contenedor-acciones-tablas">
      <div class="acciones-tabla">
        <!-- Botón de Acciones -->
      </div>
   <app-input-filter-table (filterChange)="applyFilter($event)" *ngIf="data">
      </app-input-filter-table>
    </div>
    <!-- Fin Contenedor acciones tabla -->

    <div *ngIf="data">
      <table class="mat-elevation-z8" mat-table [dataSource]="dataSource" matSort matSortStart="asc">

        <ng-container matColumnDef="descripcion">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            <strong>Descripción</strong>
          </mat-header-cell>
          <mat-cell *matCellDef="let pericia">
            <div>
              <strong>{{ pericia.descripcion | titlecase }}</strong>
              <div class="text-muted small" *ngIf="pericia.observaciones">
                {{ pericia.observaciones | slice:0:50 }}{{ pericia.observaciones?.length > 50 ? '...' : '' }}
              </div>
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="tipoPericia">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            <strong>Tipo</strong>
          </mat-header-cell>
          <mat-cell *matCellDef="let pericia">
            <span *ngIf="pericia.tipoPericia; else sinTipo">
              {{ pericia.tipoPericia.descripcion | titlecase }}
            </span>
            <ng-template #sinTipo>
              <span class="text-muted">Sin tipo</span>
            </ng-template>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="estadoPericia">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            <strong>Estado</strong>
          </mat-header-cell>
          <mat-cell *matCellDef="let pericia">
            <span *ngIf="pericia.estadoPericia; else sinEstado">
              {{ pericia.estadoPericia.descripcion | titlecase }}
            </span>
            <ng-template #sinEstado>
              <span class="text-muted">Sin estado</span>
            </ng-template>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="lugar">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            <strong>Lugar</strong>
          </mat-header-cell>
          <mat-cell *matCellDef="let pericia">
            <span *ngIf="pericia.lugar; else sinLugar">
              {{ pericia.lugar | titlecase }}
            </span>
            <ng-template #sinLugar>
              <span class="text-muted">Sin especificar</span>
            </ng-template>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="fechaPropuesta">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            <strong>Fecha Propuesta</strong>
          </mat-header-cell>
          <mat-cell *matCellDef="let pericia">
            <span *ngIf="pericia.fechaPropuesta; else sinFechaPropuesta">
              {{ pericia.fechaPropuesta | date:'dd/MM/yyyy' }}
            </span>
            <ng-template #sinFechaPropuesta>
              <span class="text-muted">Sin fecha</span>
            </ng-template>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="fechaRealizada">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            <strong>Fecha Realizada</strong>
          </mat-header-cell>
          <mat-cell *matCellDef="let pericia">
            <span *ngIf="pericia.fechaRealizada; else sinFechaRealizada">
              {{ pericia.fechaRealizada | date:'dd/MM/yyyy' }}
            </span>
            <ng-template #sinFechaRealizada>
              <span class="text-muted">Pendiente</span>
            </ng-template>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="notificacionRealizada">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            <strong>Notificación</strong>
          </mat-header-cell>
          <mat-cell *matCellDef="let pericia">
            <mat-icon *ngIf="pericia.notificacionRealizada" class="status-icon success" matTooltip="Notificado">
              check_circle
            </mat-icon>
            <mat-icon *ngIf="!pericia.notificacionRealizada" class="status-icon warning" matTooltip="Sin notificar">
              schedule
            </mat-icon>
          </mat-cell>
        </ng-container>

        <!-- Accion Column -->
        <ng-container matColumnDef="accion">
          <mat-header-cell *matHeaderCellDef>
            <strong>Acción</strong>
          </mat-header-cell>
          <mat-cell *matCellDef="let pericia" class="action-link">
            <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Menú de acciones">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="openDialog({ accion: accionesDialog.Ver, entidad: pericia })"
                *appRoles="['Pericias.Ver']">
                <mat-icon>visibility</mat-icon>
                <span>Ver</span>
              </button>
              <button mat-menu-item (click)="openDialog({ accion: accionesDialog.Modificar, entidad: pericia })"
                *appRoles="['Pericias.Modificar']">
                <mat-icon>edit</mat-icon>
                <span>Editar</span>
              </button>
              <button mat-menu-item (click)="sendEmailNotification(pericia.id)"
                *appRoles="['Pericias.Notificar']"
                [disabled]="pericia.notificacionRealizada">
                <mat-icon>email</mat-icon>
                <span>Enviar Notificación</span>
              </button>
              <button mat-menu-item (click)="openDialog({ accion: accionesDialog.Eliminar, entidad: pericia })"
                *appRoles="['Pericias.Eliminar']">
                <mat-icon>delete</mat-icon>
                <span>Eliminar</span>
              </button>
            </mat-menu>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row matRipple *matRowDef="let row; columns: displayedColumns"></mat-row>
      </table>

      <mat-paginator showFirstLastButtons class="paginator" *ngIf="data" [pageSize]="20"
        [pageSizeOptions]="[5, 10, 20, 50, 100, 200]">
      </mat-paginator>
    </div>
    <app-sin-datos-para-mostrar [dataSource]="dataSource"></app-sin-datos-para-mostrar>
  </mat-card-content>
</mat-card>
